import { createFileRoute } from '@tanstack/react-router'
import { TicketDetailView } from '@/features/ticket-detail/TicketDetailView'
import { useViewAsId } from '@/lib/viewAs'

function UserDetail() {
  const { id } = Route.useParams()
  return <TicketDetailView ticketId={id} asUser={useViewAsId()} />
}

export const Route = createFileRoute('/tickets/$id')({ component: UserDetail })
